import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {ApiRouteConfig} from "../../config/api.route.config";
import {TokenService} from "../common/services/token.service";

@Injectable()
export class LicenseService {

  constructor(
    private readonly httpClient: HttpClient,
    private readonly config: ApiRouteConfig,
    private readonly token: TokenService,
  ) {}

  public getLicense(culture: string) {
    const language = culture.substring(0,2).toUpperCase();
    return this.httpClient.get<string>(
      this.config.getRouteWithInjectedParams(this.config.GET_LICENSE, [language])
    );
  }
}
